/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config";

const AboutBanner = () => {
  return (
    <motion.div variants={animation} className="py-6 xl:py-12 lg:py-12">
      {/* TOP SECTION */}
      <div className="py-0">
        <div className="container">
          <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-5 xl:gap-20 lg:gap-20 items-center">
            <div className="col-span-1">
              <h1 className="text-3xl xl:text-4xl lg:text-4xl font-roundo font-bold text-black leading-snug">
                Empowering Institutions to Connect, Engage, and Grow Their
                Alumni Communities
              </h1>
            </div>
            <div className="col-span-1">
              <h5 className="text-lg font-source font-normal text-greyText leading-relaxed">
                Alumni Connection Hub was born from a simple idea — that alumni
                are not just part of the past, but a powerful force for the
                future. Our journey began with a mission to help universities
                foster stronger, lifelong relationships with their alumni
                through modern, intuitive, and deeply human technology.
              </h5>
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM BANNER */}
      <div className="pt-6 xl:pt-12 lg:pt-12">
        <img
          src={require("../../assets/images/about-banner.jpg")}
          className="w-full h-[50vh] xl:h-[68vh] lg:h-[68vh] object-cover"
          alt="About us"
        />
      </div>
    </motion.div>
  );
};

export default AboutBanner;
